export const _en = {
    addButton: {
        label: "Instructor role"
    },
    toggleDeleted: {
        label: "Show deleted data"
    },
    dialog: {
        add: {
            title: "Add a instructor role",
            buttons: {
                save: "Save",
                cancel: "Cancel"
            }
        }
    }
};


export const _fr = {
    addButton: {
        label: "Rôle instructeur"
    },
    toggleDeleted: {
        label: "Afficher les rôles instructeurs archivés"
    },
    dialog: {
        add: {
            title: "Ajout d'un rôle instructeur",
            buttons: {
                save: "Sauvegarder",
                cancel: "Annuler"
            }
        }
    }
};